import { Component } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-terms-content-card',
  templateUrl: './content-card.component.html',
  imports: [TranslateDirective, TranslatePipe, SafeHtmlPipe],
})
export class ContentCardComponent {
  // [1, 2, 3, ..., 13]
  items = [...Array(13).keys()].map(i => i + 1);

  getItemId(i: number): string {
    return `item${i}`;
  }
  getItemTextKey(i: number): string {
    return `terms.item${i}.text`;
  }
}
